export function isWithinOrderingWindow(now = new Date()) {
  const parts = new Intl.DateTimeFormat("sv-SE", {
    timeZone: "Europe/Sofia",
    hourCycle: "h23",
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
  }).formatToParts(now);

  const get = (type) => parts.find((part) => part.type === type)?.value ?? "";
  const time = `${get("hour")}:${get("minute")}`;
  const weekday = get("weekday").toLowerCase();
  const isSunday = weekday.startsWith("sun") || weekday.startsWith("s\u00f6n");

  const opensAt = "11:00";
  const closesAt = isSunday ? "19:00" : "20:30";

  return time >= opensAt && time <= closesAt;
}
